import { HexCorner, HexEdge, HexFace } from '@colonist/game-mechanic-validators';
import { ArrayUtils } from '@colonist/utils';
import { TileHexType, TileCornerBuildingType, TileCornerBonusType } from '@colonist/game-states';
export function getAmountToGiveForCornerPiece(piece) {
    switch(piece){
        case TileCornerBuildingType.KnightActiveLevel1:
        case TileCornerBuildingType.KnightActiveLevel2:
        case TileCornerBuildingType.KnightActiveLevel3:
        case TileCornerBuildingType.KnightInactiveLevel1:
        case TileCornerBuildingType.KnightInactiveLevel2:
        case TileCornerBuildingType.KnightInactiveLevel3:
            return 0;
        case TileCornerBuildingType.DestroyedCity:
        case TileCornerBuildingType.Settlement:
            return 1;
        case TileCornerBuildingType.City:
            return 2;
    }
}
export function isCornerBuildingKnight(cornerBuilding) {
    switch(cornerBuilding){
        case TileCornerBuildingType.KnightActiveLevel1:
        case TileCornerBuildingType.KnightActiveLevel2:
        case TileCornerBuildingType.KnightActiveLevel3:
        case TileCornerBuildingType.KnightInactiveLevel1:
        case TileCornerBuildingType.KnightInactiveLevel2:
        case TileCornerBuildingType.KnightInactiveLevel3:
            return true;
        default:
            return false;
    }
}
export class TileCorner {
    get owner() {
        return this.state.owner;
    }
    get buildingType() {
        return this.state.buildingType;
    }
    get restrictedStartingPlacement() {
        if (this.state.restrictedStartingPlacement == undefined) return false;
        return this.state.restrictedStartingPlacement;
    }
    get bonuses() {
        if (this.state.bonuses == undefined) return this.state.bonuses = [];
        return this.state.bonuses;
    }
    sameCornerLocation(otherCorner) {
        if (this.hexCorner.x != otherCorner.hexCorner.x) return false;
        if (this.hexCorner.y != otherCorner.hexCorner.y) return false;
        if (this.hexCorner.z != otherCorner.hexCorner.z) return false // noinspection RedundantIfStatementJS
        ;
        return true;
    }
    sameCorner(otherCorner) {
        if (this.owner != otherCorner.owner) return false;
        if (this.buildingType != otherCorner.buildingType) return false;
        return this.sameCornerLocation(otherCorner);
    }
    hasCornerBonusOfType(cornerBonusType) {
        for (const bonus of this.bonuses){
            if (bonus == cornerBonusType) return true;
        }
        return false;
    }
    doesCornerHaveMetropolis() {
        if (ArrayUtils.elementInArray(this.bonuses, TileCornerBonusType.MetropolisPolitics)) return true;
        if (ArrayUtils.elementInArray(this.bonuses, TileCornerBonusType.MetropolisScience)) return true;
        if (ArrayUtils.elementInArray(this.bonuses, TileCornerBonusType.MetropolisTrade)) return true;
        return false;
    }
    getMetropolis() {
        if (ArrayUtils.elementInArray(this.bonuses, TileCornerBonusType.MetropolisPolitics)) return TileCornerBonusType.MetropolisPolitics;
        if (ArrayUtils.elementInArray(this.bonuses, TileCornerBonusType.MetropolisScience)) return TileCornerBonusType.MetropolisScience;
        if (ArrayUtils.elementInArray(this.bonuses, TileCornerBonusType.MetropolisTrade)) return TileCornerBonusType.MetropolisTrade;
        return undefined;
    }
    removeCornerBonus(cornerBonus) {
        ArrayUtils.removeElementFromArray(this.bonuses, cornerBonus);
    }
    constructor(state){
        this.state = state;
        this.hexCorner = new HexCorner(this.state.x, this.state.y, this.state.z);
    }
}
export class TileEdge {
    get owner() {
        return this.state.owner;
    }
    get type() {
        return this.state.type;
    }
    sameEdge(otherEdge) {
        if (this.owner != otherEdge.owner) return false;
        if (this.type != otherEdge.type) return false;
        if (this.hexEdge.x != otherEdge.hexEdge.x) return false;
        if (this.hexEdge.y != otherEdge.hexEdge.y) return false;
        if (this.hexEdge.z != otherEdge.hexEdge.z) return false // noinspection RedundantIfStatementJS
        ;
        return true;
    }
    constructor(state){
        this.state = state;
        this.hexEdge = new HexEdge(this.state.x, this.state.y, this.state.z);
    }
}
export class TileHex {
    get tileType() {
        return this.state.type;
    }
    get diceNumber() {
        return this.state.diceNumber;
    }
    get diceProbability() {
        switch(this.diceNumber){
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 8:
                return 5;
            case 9:
                return 4;
            case 10:
                return 3;
            case 11:
                return 2;
            case 12:
                return 1;
        }
        return 0;
    }
    sameTileHex(tileHex) {
        if (tileHex.hexFace.x != this.hexFace.x) return false;
        if (tileHex.hexFace.y != this.hexFace.y) return false // noinspection RedundantIfStatementJS
        ;
        return true;
    }
    isTileHexNeighbor(tileHex) {
        const neighboringHexFaces = tileHex.hexFace.neighbors();
        for (const neighbor of neighboringHexFaces){
            if (neighbor.x != this.hexFace.x) continue;
            if (neighbor.y != this.hexFace.y) continue;
            return true;
        }
        return false;
    }
    isTileLand() {
        if (this.tileType == TileHexType.Sea) return false;
        if (this.tileType == TileHexType.Fog) return false;
        return true;
    }
    constructor(state){
        this.state = state;
        this.hexFace = new HexFace(this.state.x, this.state.y);
    }
}
